const getRecommendations = function (
    { rootState, commit },
    { types = [], productLineSlug = null } = {}
) {
    return new Promise((resolve, reject) => {
        if (types.length === 0)
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject('You have to pass types through so we know what to request.')

        const query = getRecQuery({
            fitment: rootState.fitment.data,
            permId: rootState.permId,
            types,
            productLineSlug,
        })

        return this.$axios
            .get(`${this.$config.platform.apis.recommendations}?${query}`)
            .then((response) => {
                const types = ['similar', 'related', 'recent', 'recommended']
                types.forEach((type) => {
                    commit('setValue', {
                        key: type,
                        value: response.data[type] || null,
                    })
                })

                return resolve()
            })
            .catch((err) => reject(err))
    })
}

export default {
    getRecommendations,
}

function getRecQuery({ fitment, permId, types, productLineSlug }) {
    const queryBuilder = []

    if (fitment.makeSlug) queryBuilder.push(`makeSlug=${fitment.makeSlug}`)
    if (fitment.modelSlug) queryBuilder.push(`modelSlug=${fitment.modelSlug}`)
    if (fitment.year) queryBuilder.push(`year=${fitment.year}`)
    if (fitment.bedSlug) queryBuilder.push(`bedSlug=${fitment.bedSlug}`)
    if (fitment.bodySlug) queryBuilder.push(`bodySlug=${fitment.bodySlug}`)
    if (fitment.engineSlug) queryBuilder.push(`engineSlug=${fitment.engineSlug}`)
    if (permId) queryBuilder.push(`permId=${permId}`)
    if (productLineSlug) queryBuilder.push(`productLineSlug=${productLineSlug}`)

    queryBuilder.push(`types=${types.join(',')}`)

    return queryBuilder.join('&')
}
